export const PIPE_MILL_REPORT_TYPES = [
  'CHEMICAL',
  'TENSILE',
  'CVN',
  'AUT',
  'HYDROSTATIC',
  'DIMENSIONAL',
  'HARDNESS',
  'FLATTENING',
  'BEND',
  'VISUAL',
  'RT',
  'MPT',
  'HEAT_TREAT',
  'PIPE_BODY_UT',
  'MFL_ET',
  'COATING',
  'THREAD',
  'WELD_MAP',
];

export const FETCH_PIPE_MILL_REPORTS = 'FETCH_PIPE_MILL_REPORTS';
export const FETCH_PIPE_MILL_REPORTS_SUCCESS = 'FETCH_PIPE_MILL_REPORTS_SUCCESS';
export const FETCH_PIPE_MILL_REPORTS_FAILURE = 'FETCH_PIPE_MILL_REPORTS_FAILURE';

export const FETCH_PIPE_MILL_MOCK_DATA = 'FETCH_PIPE_MILL_MOCK_DATA';
export const FETCH_PIPE_MILL_MOCK_DATA_SUCCESS = 'FETCH_PIPE_MILL_MOCK_DATA_SUCCESS';
export const FETCH_PIPE_MILL_MOCK_DATA_FAILURE = 'FETCH_PIPE_MILL_MOCK_DATA_FAILURE';

export const FETCH_PIPE_MILL_REPORT_METADATA = 'FETCH_PIPE_MILL_REPORT_METADATA';
export const FETCH_PIPE_MILL_REPORT_METADATA_SUCCESS = 'FETCH_PIPE_MILL_REPORT_METADATA_SUCCESS';
export const FETCH_PIPE_MILL_REPORT_METADATA_FAILURE = 'FETCH_PIPE_MILL_REPORT_METADATA_FAILURE';

export const SAVE_PIPE_MILL_REPORT = 'SAVE_PIPE_MILL_REPORT';
export const SAVE_PIPE_MILL_REPORT_SUCCESS = 'SAVE_PIPE_MILL_REPORT_SUCCESS';
export const SAVE_PIPE_MILL_REPORT_FAILURE = 'SAVE_PIPE_MILL_REPORT_FAILURE';

export const SAVE_BULK_PIPE_MILL_REPORTS = 'SAVE_BULK_PIPE_MILL_REPORTS';
export const SAVE_BULK_PIPE_MILL_REPORTS_SUCCESS = 'SAVE_BULK_PIPE_MILL_REPORTS_SUCCESS';
export const SAVE_BULK_PIPE_MILL_REPORTS_FAILURE = 'SAVE_BULK_PIPE_MILL_REPORTS_FAILURE';

export const SAVE_PIPE_MILL_REPORT_ITEM = 'SAVE_PIPE_MILL_REPORT_ITEM';
export const SAVE_PIPE_MILL_REPORT_ITEM_SUCCESS = 'SAVE_PIPE_MILL_REPORT_ITEM_SUCCESS';
export const SAVE_PIPE_MILL_REPORT_ITEM_FAILURE = 'SAVE_PIPE_MILL_REPORT_ITEM_FAILURE';

export const SAVE_PIPE_MILL_REPORT_STATUS = 'SAVE_PIPE_MILL_REPORT_STATUS';
export const SAVE_PIPE_MILL_REPORT_STATUS_SUCCESS = 'SAVE_PIPE_MILL_REPORT_STATUS_SUCCESS';
export const SAVE_PIPE_MILL_REPORT_STATUS_FAILURE = 'SAVE_PIPE_MILL_REPORT_STATUS_FAILURE';

export const DELETE_PIPE_MILL_REPORT = 'DELETE_PIPE_MILL_REPORT';
export const DELETE_PIPE_MILL_REPORT_SUCCESS = 'DELETE_PIPE_MILL_REPORT_SUCCESS';
export const DELETE_PIPE_MILL_REPORT_FAILURE = 'DELETE_PIPE_MILL_REPORT_FAILURE';

export const DELETE_PIPE_MILL_REPORT_ITEM = 'DELETE_PIPE_MILL_REPORT_ITEM';
export const DELETE_PIPE_MILL_REPORT_ITEM_SUCCESS = 'DELETE_PIPE_MILL_REPORT_ITEM_SUCCESS';
export const DELETE_PIPE_MILL_REPORT_ITEM_FAILURE = 'DELETE_PIPE_MILL_REPORT_ITEM_FAILURE';

export const EVALUATE_PIPE_MILL_REPORT = 'EVALUATE_PIPE_MILL_REPORT';
export const EVALUATE_PIPE_MILL_REPORT_SUCCESS = 'EVALUATE_PIPE_MILL_REPORT_SUCCESS';
export const EVALUATE_PIPE_MILL_REPORT_FAILURE = 'EVALUATE_PIPE_MILL_REPORT_FAILURE';

export const FETCH_PIPE_MILL_PROJECT_LIMITS = 'FETCH_PIPE_MILL_PROJECT_LIMITS';
export const FETCH_PIPE_MILL_PROJECT_LIMITS_SUCCESS = 'FETCH_PIPE_MILL_PROJECT_LIMITS_SUCCESS';
export const FETCH_PIPE_MILL_PROJECT_LIMITS_FAILURE = 'FETCH_PIPE_MILL_PROJECT_LIMITS_FAILURE';

export const SAVE_PIPE_MILL_PROJECT_LIMIT = 'SAVE_PIPE_MILL_PROJECT_LIMIT';
export const SAVE_PIPE_MILL_PROJECT_LIMIT_SUCCESS = 'SAVE_PIPE_MILL_PROJECT_LIMIT_SUCCESS';
export const SAVE_PIPE_MILL_PROJECT_LIMIT_FAILURE = 'SAVE_PIPE_MILL_PROJECT_LIMIT_FAILURE';

export const DELETE_PIPE_MILL_PROJECT_LIMIT = 'DELETE_PIPE_MILL_PROJECT_LIMIT';
export const DELETE_PIPE_MILL_PROJECT_LIMIT_SUCCESS = 'DELETE_PIPE_MILL_PROJECT_LIMIT_SUCCESS';
export const DELETE_PIPE_MILL_PROJECT_LIMIT_FAILURE = 'DELETE_PIPE_MILL_PROJECT_LIMIT_FAILURE';

export const FETCH_PIPE_MILL_FREQUENCY_RULES = 'FETCH_PIPE_MILL_FREQUENCY_RULES';
export const FETCH_PIPE_MILL_FREQUENCY_RULES_SUCCESS = 'FETCH_PIPE_MILL_FREQUENCY_RULES_SUCCESS';
export const FETCH_PIPE_MILL_FREQUENCY_RULES_FAILURE = 'FETCH_PIPE_MILL_FREQUENCY_RULES_FAILURE';

export const SAVE_PIPE_MILL_FREQUENCY_RULE = 'SAVE_PIPE_MILL_FREQUENCY_RULE';
export const SAVE_PIPE_MILL_FREQUENCY_RULE_SUCCESS = 'SAVE_PIPE_MILL_FREQUENCY_RULE_SUCCESS';
export const SAVE_PIPE_MILL_FREQUENCY_RULE_FAILURE = 'SAVE_PIPE_MILL_FREQUENCY_RULE_FAILURE';

export const DELETE_PIPE_MILL_FREQUENCY_RULE = 'DELETE_PIPE_MILL_FREQUENCY_RULE';
export const DELETE_PIPE_MILL_FREQUENCY_RULE_SUCCESS = 'DELETE_PIPE_MILL_FREQUENCY_RULE_SUCCESS';
export const DELETE_PIPE_MILL_FREQUENCY_RULE_FAILURE = 'DELETE_PIPE_MILL_FREQUENCY_RULE_FAILURE';

export const FETCH_PIPE_MILL_CLEARANCE_STATUS = 'FETCH_PIPE_MILL_CLEARANCE_STATUS';
export const FETCH_PIPE_MILL_CLEARANCE_STATUS_SUCCESS = 'FETCH_PIPE_MILL_CLEARANCE_STATUS_SUCCESS';
export const FETCH_PIPE_MILL_CLEARANCE_STATUS_FAILURE = 'FETCH_PIPE_MILL_CLEARANCE_STATUS_FAILURE';

export const CLEAR_PIPE_MILL_REPORT_SAVE_STATUS = 'CLEAR_PIPE_MILL_REPORT_SAVE_STATUS';
export const CLEAR_PIPE_MILL_REPORT_ERRORS = 'CLEAR_PIPE_MILL_REPORT_ERRORS';
